/* eslint-disable no-unused-vars */
export enum ClaimContestOption {
  AGREE = "AGREE",
  DISAGREE = "DISAGREE",
}
